const addTrailingSlash = (url) => {

    // Check if the last character is a slash
    if (url.charAt(url.length - 1) !== '/') {

        // If not, append a slash to the end of the URL
        url += '/';

    }
    return url;

};

const getBlogBaseURI = () => {

    return addTrailingSlash(location.pathname.replace(/\/category\/[\w-]+/, ''));

};

const getCategoryParamFromURL = () => {

    // Use regular expression to match the category parameter from the URL path
    const categoryMatch = location.pathname.match(/\/category\/([^\/?]+)/);
    return categoryMatch ? categoryMatch[1] : null;

};

const getUtmParams = () => {

    const params = new URLSearchParams(window.location.search);
    const utmParams = []; const allowedPrefixes = ['utm_', 'adara'];
    const allowedExactMatches = ['gclid', 'dclid', 'msclkid', 'fbclid', 'ttclid', 'twclid', 'li_fat_id', 's_cid', 'cid', 'ad_id', 'campaign_id', 'creative_id', 'aff_id', 'ref'];

    params.forEach((value, key) => {

        if (allowedPrefixes.some((prefix) => key.startsWith(prefix)) || allowedExactMatches.includes(key)) {

            utmParams.push({ key, value });

        }

    });

    return utmParams;

};

export {
    getBlogBaseURI,
    getCategoryParamFromURL,
    getUtmParams,
};
